function isMobileDevice() {
  return (
    typeof window.orientation !== "undefined" ||
    navigator.userAgent.indexOf("IEMobile") !== -1
  );
}

document.addEventListener("turbolinks:load", function() {
  $(document).ready(function() {
    if(isMobileDevice()) {
      $('.mobile-only').show() 
    } else {
      $('.mobile-only').hide()
    }
  
    if(!isMobileDevice()) {
      $('.desktop-only').show() 
    } else {
      $('.desktop-only').hide()
    }
  });
})


window.isMobileDevice = isMobileDevice;